import { DOCUMENT } from '@angular/common';
import { provideHttpClient,HttpClient } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { NoPreloading, provideRouter, withPreloading } from '@angular/router';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { DEFAULT_LANG, SUPPORTED_LANGS } from './core/i18n/supported-langs';
import { GigyaLoaderService } from './core/services/gigya-loader.service';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withPreloading(NoPreloading)),
    provideMarkdown({ loader: HttpClient }),
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: DEFAULT_LANG,
      lang: DEFAULT_LANG,
    }),
    provideAppInitializer(() => {
      inject(GigyaLoaderService).load();

      const translate = inject(TranslateService);
      const document = inject(DOCUMENT);

      translate.onLangChange.subscribe(({ lang }) => {
        document.documentElement.lang = lang;
      });

      const saved = localStorage.getItem('lang');
      if (saved && (SUPPORTED_LANGS as readonly string[]).includes(saved)) {
        translate.use(saved);
        document.documentElement.lang = saved;
      }
    }),
  ],
};
